import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzWaveModule } from "ng-zorro-antd/core/wave";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { NzButtonModule } from "ng-zorro-antd/button";
import { CoreModule } from "@webapp/core/core.module";
import { GhFullNameComponent } from "@webapp/ui/gh-full-name/gh-full-name.component";
import { GhIndicatorComponent } from "@webapp/ui/gh-indicator/gh-indicator.component";
import { NzDrawerModule } from "ng-zorro-antd/drawer";
import { NzNoAnimationModule } from "ng-zorro-antd/core/no-animation";
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { uiKitDeclarations, uiKitExports } from "@webapp/ui/index";
import { NzPipesModule } from "ng-zorro-antd/pipes";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzOverlayModule } from "ng-zorro-antd/core/overlay";
import { NzEmptyModule } from "ng-zorro-antd/empty";
import { NzDestroyService } from "ng-zorro-antd/core/services";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzMentionModule } from "ng-zorro-antd/mention";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { UiContextMenuService } from "@webapp/ui/core/services/context-menu.service";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzListModule } from "ng-zorro-antd/list";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzGridModule } from "ng-zorro-antd/grid";

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    OverlayModule,
    PortalModule,
    FormsModule,
    NzIconModule,
    NzAvatarModule,
    NzSwitchModule,
    NzWaveModule,
    NzOutletModule,
    NzButtonModule,
    NzDrawerModule,
    NzNoAnimationModule,
    NzPipesModule,
    NzMenuModule,
    NzDividerModule,
    NzOverlayModule,
    NzSkeletonModule,
    NzEmptyModule,
    NzRadioModule,
    NzMentionModule,
    NzCollapseModule,
    NzDropDownModule,
    NzTabsModule,
    NzBadgeModule,
    NzNoAnimationModule,
    NzListModule,
    NzSpinModule,
    NzGridModule,
  ],
  exports: [...uiKitExports, GhFullNameComponent, GhIndicatorComponent, CoreModule],
  declarations: [...uiKitDeclarations, GhFullNameComponent, GhIndicatorComponent],
})
export class UiModule {
  public static forRoot(): {
    ngModule: typeof UiModule;
    providers: (typeof NzDestroyService | typeof UiContextMenuService)[];
  } {
    return {
      ngModule: UiModule,
      providers: [NzDestroyService, UiContextMenuService],
    };
  }
}
